import React from "react";

const TreeSvg = () => (
  <svg
    viewBox="0 0 130 109"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <path
      d="M25.894 63.11C11.591 63.108-.001 51.514 0 37.213c0-14.302 11.594-25.894 25.896-25.894 10.424.001 19.41 6.162 23.515 15.041a25.878 25.878 0 0 0-10.168 6.212c-2.653-6.859-9.312-11.722-17.108-11.724-10.127 0-18.337 8.209-18.337 18.336-.001 10.127 8.208 18.338 18.336 18.338a18.25 18.25 0 0 0 9.696-2.771 25.72 25.72 0 0 0 2.105 7.085 25.906 25.906 0 0 1-8.041 1.274z"
      fill="#6DA14E"
    />
    <path
      d="M22.134 57.522c-10.128 0-18.337-8.211-18.336-18.338 0-10.127 8.21-18.336 18.337-18.336 7.796.002 14.455 4.865 17.108 11.724a25.942 25.942 0 0 0-5.491 7.962l-8.918 8.917 2.122 2.122 4.971-4.971a25.976 25.976 0 0 0-.369 4.377 25.925 25.925 0 0 0 .272 3.772 18.25 18.25 0 0 1-9.696 2.771z"
      fill="#4E833E"
    />
    <path d="M24.395 108.94h3V32.539h-3v76.401z" fill="#E6832D" />
    <path
      d="M26.956 51.573l11.326-11.326-2.122-2.122-11.326 11.326 2.122 2.122z"
      fill="#E6832D"
    />
    <path
      d="M96.912 65.493h-.033a32.299 32.299 0 0 1-15.721-4.076c.423-.959.789-1.948 1.094-2.964a19.443 19.443 0 0 0 10.641 3.165h.02c5.868 0 11.134-2.591 14.715-6.69 10.102-2.98 17.481-12.32 17.493-23.389.013-13.48-10.903-24.42-24.384-24.433h-.027c-13.468 0-24.394 10.911-24.408 24.382l.002.324c-.18.289-.352.584-.517.884a25.89 25.89 0 0 0-10.611-6.438C68.297 11.592 81.325.596 96.915.596h.033c17.921.02 32.433 14.563 32.414 32.484-.018 17.909-14.545 32.413-32.45 32.413z"
      fill="#6DA14E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.628 54.928a19.45 19.45 0 0 0 4.814-12.818c.011-10.785-8.723-19.537-19.509-19.549h-.022c-7.012 0-13.163 3.697-16.607 9.251a35.211 35.211 0 0 1-.002-.324c.014-13.471 10.94-24.382 24.408-24.382h.027c13.481.013 24.397 10.953 24.384 24.433-.012 11.069-7.391 20.409-17.493 23.389z"
      fill="#4E833E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.45 76.876c-10.425-.001-19.41-6.162-23.515-15.04C44.3 58.452 51.789 48.709 51.789 37.215c0-3.876-.852-7.554-2.378-10.855a25.866 25.866 0 0 1 8.044-1.274c2.689.001 5.282.411 7.721 1.172a32.583 32.583 0 0 0-.712 6.752c-.012 12.215 6.726 22.861 16.694 28.407-4.015 9.104-13.121 15.459-23.708 15.459z"
      fill="#6DA14E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.935 61.836a25.72 25.72 0 0 1-2.105-7.085c5.189-3.238 8.641-8.998 8.641-15.565 0-2.332-.435-4.562-1.228-6.614a25.878 25.878 0 0 1 10.168-6.212 25.804 25.804 0 0 1 2.378 10.855c0 11.494-7.489 21.237-17.854 24.621z"
      fill="#356835"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.83 54.751a25.925 25.925 0 0 1-.272-3.772c0-1.492.126-2.955.369-4.377l6.355-6.355-2.122-2.122-2.408 2.409a25.942 25.942 0 0 1 5.491-7.962 18.309 18.309 0 0 1 1.228 6.614c0 6.567-3.452 12.327-8.641 15.565z"
      fill="#28512C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.927 46.602a25.686 25.686 0 0 1 1.825-6.068l2.408-2.409 2.122 2.122-6.355 6.355z"
      fill="#625529"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M81.158 61.417C71.19 55.871 64.452 45.225 64.464 33.01c.003-2.315.248-4.574.712-6.752a25.89 25.89 0 0 1 10.611 6.438 19.453 19.453 0 0 0-2.403 9.373c-.007 6.859 3.523 12.895 8.868 16.384a25.534 25.534 0 0 1-1.094 2.964z"
      fill="#356835"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.913 61.618h-.02a19.443 19.443 0 0 1-10.641-3.165 25.864 25.864 0 0 0 1.095-7.469c0-.82-.038-1.63-.112-2.43a24.332 24.332 0 0 0 17.451 7.368h.025c2.402 0 4.724-.347 6.917-.994-3.581 4.099-8.847 6.69-14.715 6.69zM76.366 33.295a25.14 25.14 0 0 0-.579-.599c.165-.3.337-.595.517-.884.006.498.027.992.062 1.483z"
      fill="#467A3C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.711 55.922h-.025a24.332 24.332 0 0 1-17.451-7.368 25.802 25.802 0 0 0-6.869-15.259 25.098 25.098 0 0 1-.062-1.483c3.444-5.554 9.595-9.251 16.607-9.251h.022c10.786.012 19.52 8.764 19.509 19.549a19.45 19.45 0 0 1-4.814 12.818 24.412 24.412 0 0 1-6.917.994z"
      fill="#316232"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.252 58.453c-5.345-3.489-8.875-9.525-8.868-16.384a19.453 19.453 0 0 1 2.403-9.373c.197.197.389.396.579.599a24.334 24.334 0 0 0 6.869 15.259c.074.8.112 1.61.112 2.43 0 2.597-.383 5.105-1.095 7.469z"
      fill="#274D29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.235 48.554a24.334 24.334 0 0 1-6.869-15.259 25.802 25.802 0 0 1 6.869 15.259z"
      fill="#233E23"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.555 108.94h3V32.539h-3v76.401z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.116 51.573l11.326-11.326-2.121-2.122-11.327 11.326M94.116 89.27l11.326-11.326-2.121-2.122-11.327 11.327 2.122 2.121zM55.953 108.94h3V52.905h-3v56.035z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.513 68.591L47.847 57.924l-2.121 2.121 10.666 10.667M26.956 79.258L16.29 68.592l-2.122 2.121 10.666 10.666"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.187 83.454h-.009a8.43 8.43 0 0 1-5.342-1.904l3.606-3.606-2.121-2.122-3.443 3.443a8.47 8.47 0 0 1 7.311-12.749h.007a8.469 8.469 0 0 1 8.46 8.478 8.468 8.468 0 0 1-8.469 8.46z"
      fill="#6DA14E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.836 81.55a8.487 8.487 0 0 1-1.958-2.285l3.443-3.443 2.121 2.122-3.606 3.606z"
      fill="#625529"
    />
  </svg>
);

export default TreeSvg;
